import { render, staticRenderFns } from "./StTeaserRcPress.vue?vue&type=template&id=3a3731b9"
import script from "./StTeaserRcPress.vue?vue&type=script&lang=ts"
export * from "./StTeaserRcPress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports